export default function calculateNextStep(
  currentStep,
  currentStepStack,
  workflow,
  workflowStack,
  lastAnswer
) {
  const nextStepIndex = workflow.indexOf(currentStep) + 1

  // If the current question you've answers has a sub-workflow
  // then step down into that floww
  if (lastAnswer && lastAnswer.workflow) {
    return {
      workflowStack: [...workflowStack, workflow],
      currentStepStack: [...currentStepStack, currentStep],
      workflow: lastAnswer.workflow,
      currentStep: lastAnswer.workflow[0],
    }
  }
  // If the current answer doesnt have a sub workflow but does have a sibling
  // step, then move on to that next sibling step
  if (nextStepIndex < workflow.length) {
    return {
      workflowStack,
      currentStepStack,
      workflow,
      currentStep: workflow[nextStepIndex],
    }
  }
  // If the current answer has no sub workflow and no more siblings,
  // then check if this answer is part of a sub workflow and move back up
  // to the parent workflow
  if (workflowStack.length > 0) {
    const parentWorkflow = workflowStack[workflowStack.length - 1]
    const parentCurrentStep = currentStepStack[currentStepStack.length - 1]
    return calculateNextStep(
      parentCurrentStep,
      currentStepStack.slice(0, -1),
      parentWorkflow,
      workflowStack.slice(0, -1)
    )
  }

  // This final case means that there are no more steps left in the workflow
  // at this stage we should fire the onComplete event
  return {
    workflowStack,
    currentStepStack,
    workflow,
    currentStep: {},
  }
}
